import { SHStack } from "@components/design-systems";
import { SHRichTextTooltip } from "@components/design-systems/sh-rich-text-tooltip";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { AnalysisDataDTO } from "@models/platform-analysis/entities/steps/feature";
import { Link, useTheme } from "@mui/material";
import { isNil } from "lodash";
import { memo } from "react";
import { BooleanCell } from "../boolean-cell";

type Props = {
  analysisData?: AnalysisDataDTO | MAAnalysisDataDTO;
};

export const LongTextCell = memo(({ analysisData }: Props) => {
  const isPositiveScore =
    analysisData && analysisData && "isPositiveScore" in analysisData
      ? analysisData?.isPositiveScore
      : undefined;
  const value = analysisData?.value;

  const { palette } = useTheme();

  return (
    <SHStack direction={"row"} gap={0.5}>
      <SHRichTextTooltip
        htmlContent={value}
        height={"fit-content"}
        customIcon={
          <Link
            variant="body1"
            component="label"
            underline="none"
            sx={{
              paddingLeft: "5px",
              fontWeight: 500,
              cursor: "pointer",
              color: palette.text.secondary,
              lineHeight: 1.2,
            }}
          >
            Click to view
          </Link>
        }
      />
      {!isNil(isPositiveScore) && <BooleanCell value={isPositiveScore} />}
    </SHStack>
  );
});
